import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { KycService } from '@app/core/kyc.service';
import { Injectable } from '@angular/core';

@Injectable()
export class SaveRouteGuard implements CanActivate {

    constructor(private kycService: KycService, private router: Router) {
    }
    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): boolean {
        const isSaveCompleted = this.kycService.kyc.save.completed;
        if (!isSaveCompleted) {
            let tenant = this.kycService.getTenant();
            this.router.navigate([tenant, 'journey', 'profile']);
            return false;
        }

        
        return true;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/common/route-guard/save-route-guard.ts